<template>
  <div class="error-page">
    <div class="error-text">
      <img v-if="isLogoAvailable && logoPath" :src="logoPath" :alt="'logo-demo'">
      <p v-if="errorMsg" class="error-msg">
        {{ $t(`errors.${errorMsg}`) }}
      </p>
    </div>
    <div v-if="errorText" class="error-footer">
      <h1><span><span v-if="errorCode">{{ errorCode }} - </span>{{ $t(`errors.${errorText}`) }}</span></h1>
    </div>
  </div>
</template>

<script>
import { getPartnerLogo } from '@/utils.js'
import { i18n } from '@/i18n.js'
import { mapState } from 'pinia'
import { tokenStore } from '@/stores/tokenStore.js'
import { store } from '@/stores/index.js'

export default {
  name: 'ErrorPage',
  props: {
    errorCode: {
      type: String,
      default: null
    },
    errorText: {
      type: String,
      default: null
    },
    errorMsg: {
      type: String,
      default: function () {
        return i18n.t('errors.tokenRevoked')
      }
    }
  },
  data() {
    return {
      logoPath: null,
      tokenStore: tokenStore()
    }
  },
  computed: {
    ...mapState(store, ['currentPartner']),
    isLogoAvailable() {
      if (this.tokenStore?.payload?.partner != null && this.tokenStore?.payload?.partner != '') {
        this.logoPath = getPartnerLogo(this.tokenStore?.payload?.partner)
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
.error {
  margin: auto
}

.error-text h1 {
  margin-bottom: 1em;
  line-height: 1em;
  margin: 2.5em;
}

.error-text img {
  width: 250px;
  margin: 1em;
}

.error-msg {
  margin: 1.25em;
  color: black;
}

.error-footer {
  position: absolute;
  bottom: 0em;
  left: 50%;
  transform: translateX(-50%);
}
</style>
